// extracted by mini-css-extract-plugin
export default {"root":"lws7IPwtf5FTme85xEsP"};